module.exports = __webpack_public_path__ + "static/media/IMG_3666.f2838959.jpg";